import React from "react";
import Col from "react-bootstrap/Col";
import Stack from "react-bootstrap/Stack";
import PropTypes from "prop-types";
import CardSkeleton from "../ui/Skeleton/CardSkeleton";
const Skeleton = () => {
  return (
    <Col>
      <CardSkeleton />
    </Col>
  );
};

const GenericWidget = ({
  icon,
  sizexs,
  sizesm,
  className,
  title,
  legend,
  quantity,
  loading,
}) => {
  if (loading) return <Skeleton />;

  return (
    <>
      <Col xs={sizexs} sm={sizesm} md={sizesm} lg={sizesm} xl={sizesm}>
        <div className={className}>
          <h6>{legend}</h6>
          <Stack direction="horizontal" gap={2}>
            <div>{icon}</div>
            <div className="ms-auto text-truncate">
              <h4>{quantity}</h4>
            </div>
          </Stack>
          <div className="details">{title}</div>
        </div>
      </Col>
    </>
  );
};
GenericWidget.propTypes = {
  icon: PropTypes.element,
  sizexs: PropTypes.number,
  sizesm: PropTypes.number,
  className: PropTypes.string,
  title: PropTypes.string,
  legend: PropTypes.string,
  quantity: PropTypes.number,
  loading: PropTypes.bool,
};
export default GenericWidget;
